import { PermissionPanelHeaderProps } from './types'
import { Space, Typography } from 'antd'
import CIMSCheckbox from 'components/CIMSCheckbox'
import { Permission, CIMSModuleItem, CIMSPageItem } from '@cims-online/shared'
import { useCallback } from 'react'

const PermissionPanelHeader: React.FC<PermissionPanelHeaderProps> = ({
  item,
  loading,
  disabled = false,
  rolePermissions,
  isChecked,
  setChecked,
}) => {
  const isIndeterminate = useCallback(
    (item: CIMSModuleItem | CIMSPageItem) => {
      const permissions = Permission.findByModuleOrPage(item)
      const every = permissions.every(isChecked)
      const some = permissions.some(isChecked)
      return !every && some
    },
    [isChecked]
  )
  const onHeaderChange = useCallback(
    (item: CIMSModuleItem | CIMSPageItem) => {
      const permissions = Permission.findByModuleOrPage(item)
      const indeterminate = isIndeterminate(item)
      const none = permissions.every(isChecked)
      setChecked(indeterminate || !none, permissions)
    },
    [isIndeterminate, isChecked, setChecked]
  )

  return (
    <Space size="small" align="center">
      <CIMSCheckbox
        disabled={[
          { disabled: loading ?? false, reason: 'loading' },
          {
            disabled: Permission.findByModuleOrPage(item).every((permission) =>
              rolePermissions.includes(permission.id)
            ),
            reason: {
              why: 'disabled',
              message: `All permissions in this section are assigned by Role`,
            },
          },
          {
            disabled,
            reason: {
              why: 'disabled',
              message: 'Permission Editor is disabled',
            },
          },
        ]}
        indeterminate={isIndeterminate(item)}
        checked={Permission.findByModuleOrPage(item).every(isChecked)}
        onChange={() => onHeaderChange(item)}
      />
      <Typography.Text>{item.name}</Typography.Text>
    </Space>
  )
}

export default PermissionPanelHeader
